{
  "nav": {
    "home": "Domov",
    "pick": "Izbira",
    "leaderboard": "Lestvica",
    "profile": "Profil",
    "leagues": "Lige",
    "active_league": "Aktivna Liga"
  },
  "common": {
    "error_data": "Napaka pri nalaganju podatkov.",
    "stage": "Etapa",
    "go": "POJDI",
    "back": "← Nazaj",
    "one_day_race": "Enodnevna dirka",
    "tomorrow": "Jutri",
    "in_days_one": "Jutri",
    "in_days_many": "Čez {{count}} dni",
    "in_days_other": "Čez {{count}} dni",
    "at_hours": "Ob {{hours}}",
    "loading": "Nalaganje...",
    "confirm": "POTRDI",
    "logout": "ODJAVA",
    "in_days": "Čez {{count}} dni",
    "error_generic": "Prišlo je do napake.",
    "optional": "neobvezno",
    "tu": "TI",
    "error_title": "Napaka",
    "send": "Pošlji",
    "retry": "Poskusi znova",
    "load_error_title": "Podatkov ni mogoče naložiti",
    "load_error_sub": "Preveri povezavo in poskusi znova.",
    "stale_data": "Podatki morda niso posodobljeni: prikazani so shranjeni."
  },
  "home": {
    "participants": "udeleženci",
    "section_results": "Zadnji rezultati",
    "section_upcoming": "Prihajajoče dirke",
    "social": "Sledi nam na družbenih omrežjih",
    "onboarding_next": "Naprej →",
    "onboarding_start": "Začni igrati →",
    "onboarding_rules": "Preberi pravila",
    "section_picks": "Izbire, ki jih moraš narediti",
    "no_races": "Trenutno ni dirk za izbiro",
    "other_picks_one": "še ena izbira →",
    "other_picks_many": "še {{count}} izbire →",
    "other_picks_other": "še {{count}} izbir →",
    "stage_results": "Lestvica",
    "tab_stage": "ETAPA",
    "tab_gc": "SKUPNO",
    "no_data": "Ni razpoložljivih podatkov",
    "onboarding_step1_title": "Dobrodošel v Virtua Cycling!",
    "onboarding_step1_body": "Fantazijska igra profesionalnega kolesarstva.",
    "onboarding_step2_title": "Kako deluje",
    "onboarding_item1": "Izberi svoje kolesarje — Pred vsako etapo izbereš kolesarje, na katere staviš. Čas imaš do starta.",
    "onboarding_item2": "Zbiraj točke — Tvoji kolesarji dobijo točke glede na dejansko uvrstitev v etapi in v skupnem seštevku.",
    "onboarding_item3": "Ustvari svojo ligo — Tekmuj z drugimi udeleženci etapo za etapo in se povzpni na skupni lestvici.",
    "onboarding_step3_title": "Pripravljen si!",
    "onboarding_step3_body": "Nahajaš se v Virtua Cycling League, splošni ligi, kjer igrajo vsi. Preberi celoten pravilnik, da ti nič ne uide.",
    "kofi_cta": "Ti je aplikacija všeč? Ponudi nam pivo!",
    "jersey_gc": "Majica vodilnega v skupni razvrstitvi",
    "jersey_pt": "Majica za točke",
    "jersey_gm": "Gorska majica",
    "greeting": "Živjo, {{name}}",
    "status_ready": "Izbire potrjene za naslednjo etapo",
    "status_todo": "Svojih izbir še nisi opravil",
    "retry": "Poskusi znova"
  },
  "pick": {
    "live_label": "V ŽIVO",
    "pick_done": "Izbira že opravljena — še jo lahko spremeniš",
    "no_pick_stage": "Za to etapo ni bilo najdene nobene izbire.",
    "error_load": "Napaka pri nalaganju dirk.",
    "loading": "Nalaganje...",
    "title": "Izbira",
    "no_races_title": "Nobena dirka ni na voljo",
    "no_races_sub": "Trenutno ni predvidenih dirk. Vrni se kmalu!",
    "banned_title": "Izstop iz dirke",
    "banned_stages_one": "Izpustil si 1 etapo",
    "banned_stages_many": "Izpustil si {{count}} etape",
    "banned_stages_other": "Izpustil si {{count}} etap",
    "banned_detail": "Lahko spremljaš rezultate in izbire drugih, ne moreš pa sodelovati v tej izdaji.",
    "banned_message": "Se vidimo naslednjič!",
    "stage_finished": "Etapa je zaključena. Tukaj so opravljene izbire.",
    "live_alert": "Dirka poteka — postave zaklenjene",
    "startlist_btn": "Startna lista",
    "startlist_title": "Startna lista",
    "startlist_search": "Išči številko ali ime",
    "startlist_dnf": "Odstopil",
    "startlist_empty": "Startna lista še ni na voljo",
    "tab_insert": "Vnos",
    "tab_summary": "Povzetek",
    "start_list_title": "Startna lista še ni pripravljena",
    "start_list_sub": "Seznam udeležencev bo objavljen v kratkem. Preveri kasneje.",
    "need_more_one": "Izberi še {{count}} kolesarja.",
    "need_more_many": "Izberi še {{count}} kolesarje.",
    "need_more_other": "Izberi še {{count}} kolesarjev.",
    "error_save": "Napaka pri shranjevanju.",
    "loading_riders": "Nalaganje kolesarjev...",
    "draft_restored": "Osnutek obnovljen",
    "draft_count_one": "1 kolesar shranjen lokalno",
    "draft_count_many": "{{count}} kolesarji shranjeni lokalno",
    "draft_count_other": "{{count}} kolesarjev shranjenih lokalno",
    "draft_cancel": "Prekliči",
    "select_n_one": "Izberi {{count}} kolesarja",
    "select_n_many": "Izberi {{count}} kolesarje",
    "select_n_other": "Izberi {{count}} kolesarjev",
    "add_rider": "+ Dodaj kolesarja ({{current}}/{{limit}})",
    "edit_selection": "Uredi izbiro",
    "apply_all": "Uporabi izbiro za vse moje lige",
    "saved_for": "Shranjeno za: {{leagues}}",
    "flip_used": "Flip — uporabljen",
    "flip_available": "Flip — na voljo",
    "flip_remove": "Odstrani",
    "flip_abbinato": "{{rider}} povezan z mestom {{slot}}",
    "flip_confirmed": "Flip je bil prijavljen za to etapo. Pri obračunu točk bo izbran boljši od obeh.",
    "flip_slot_label": "S katerim mestom povežeš flip?",
    "flip_confirm_btn": "Potrdi flip",
    "saving": "Shranjevanje...",
    "confirm_pick": "POTRDI IZBIRO {{current}}/{{limit}}",
    "select_riders": "Izberi kolesarje",
    "search_rider": "Išči kolesarja...",
    "no_rider_found": "Noben kolesar ni bil najden",
    "compare_users": "Primerjaj uporabnike",
    "confirm": "Potrdi",
    "no_pick_found": "Nobena izbira ni bila najdena.",
    "toast_multi_one": "Izbire shranjene za 1 ligo",
    "toast_multi_many": "Izbire shranjene za {{count}} lige",
    "toast_multi_other": "Izbire shranjene za {{count}} lig",
    "toast_single": "Izbire shranjene!",
    "compare_with": "Primerjaj z {{names}}",
    "compare_default": "Primerjaj z drugimi uporabniki (najv. {{max}})",
    "tap_to_change": "• dotakni se za spremembo",
    "you": "(TI)",
    "matrix_hint": "Tapni kolesarja, da vidiš, kdo ga je izbral",
    "user_col": "Uporabnik",
    "scout_title": "Skavtsko poročilo",
    "scout_top_rider": "Najbolj izbran kolesar",
    "scout_distribution": "Porazdelitev po mestih",
    "scout_variety": "Raznolikost lige",
    "scout_distinct": "Izbranih različnih kolesarjev",
    "scout_identical": "Identične postave",
    "scout_no_picks": "Opravi svoje izbire, da vidiš, koliko igralcev ima enako postavo kot ti",
    "loading_lineups": "Nalaganje postav...",
    "collapse_all": "ZAPRI VSE",
    "expand_all": "RAZŠIRI VSE",
    "no_races": "Trenutno ni razpoložljivih dirk.",
    "add_rider_one": "+ Dodaj kolesarja ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} je bil že postavljen v prejšnji etapi!",
    "draft_count": "Lokalno imaš shranjenih {{count}} kolesarjev",
    "toast_multi": "Izbire shranjene za {{count}} lig",
    "scout_chosen_by": "Izbrali: {{names}}",
    "scout_chosen_by_others": "Izbrali: {{names}} in še {{count}} drugih",
    "scout_sharing": "Deljenje...",
    "scout_share_btn": "Deli skavtsko poročilo",
    "scout_outsider": "Autsajder",
    "scout_contrarian": "Najpogumnejša izbira",
    "scout_slot": "MESTO {{n}}",
    "scout_players": "{{count}} igralcev",
    "draft_unsaved_banner": "Izbira ni potrjena — pritisni Potrdi, da jo shraniš",
    "draft_unsaved_title": "Izbira ni potrjena",
    "draft_unsaved_body": "Imaš neshranjeno izbiro. Ali jo želiš potrditi, preden zapustiš stran?",
    "draft_exit": "Zapusti brez shranjevanja",
    "draft_confirm_now": "Ostani in potrdi",
    "share_all": "Vsi",
    "current_league": "Trenutna liga",
    "duplicate_rider_reason": "Že uporabljen: {{name}}",
    "flip_saved": "Flip shranjen!",
    "flip_deleted": "Flip odstranjen.",
    "flip_add_rider": "+ Dodaj flip kolesarja (neobvezno)",
    "riders_count_one": "1 kolesar",
    "riders_count_many": "{{count}} kolesarji",
    "riders_count_other": "{{count}} kolesarjev",
    "riders_selected_one": "1 izbran",
    "riders_selected_many": "{{count}} izbrani",
    "riders_selected_other": "{{count}} izbranih",
    "search_user": "Išči uporabnika...",
    "tab_per_tappa": "Po etapah",
    "tab_matrice": "Prisotnost kolesarjev",
    "matrix_select_riders": "Izberi kolesarje za spremljanje (najv. 5)",
    "no_picks_riepilogo": "Nobena izbira ni bila najdena",
    "no_picks_riepilogo_sub": "Za to dirko še nisi opravil izbire.",
    "scout_avg_pct": "~{{pct}}% v povprečju",
    "scout_no_identical": "Nihče drug nima enake postave kot ti",
    "scout_identical_count_one": "1 igralec ima enako postavo kot ti",
    "scout_identical_count_many": "{{count}} igralci imajo enako postavo kot ti",
    "scout_identical_count_other": "{{count}} igralcev ima enako postavo kot ti",
    "scout_share_dialog": "Skavtsko poročilo — {{name}}",
    "share_hidden": "+ ŠE {{count}} IGRALCEV · ODPRI APLIKACIJO",
    "no_picks_tabella": "Nobena postava ni bila poslana",
    "no_picks_tabella_sub": "Tukaj se bodo prikazale izbire drugih igralcev.",
    "flip_slot_arrow": "→ mesto {{slot}}",
    "race_tag_pick": "IZBERI",
    "race_tag_live": "V ŽIVO",
    "race_tag_done": "KONČANA",
    "race_switcher_label": "Dirke",
    "race_history": "Zgodovina dirk",
    "race_group_next": "Prihajajoče",
    "race_group_past": "Pretekle",
    "close": "Zapri",
    "prev_stage": "Prejšnja etapa",
    "next_stage": "Naslednja etapa",
    "stage_list_title": "Etape",
    "matrix_chosen_by": "{{name}} · izbralo {{count}} od {{total}}",
    "matrix_clear": "Počisti izbiro",
    "matrix_chosen_by_a11y": "izbralo {{count}} od {{total}} igralcev",
    "matrix_open_player": "Odpri izbire igralca {{name}}",
    "sheet_chosen_by": "{{count}} od {{total}}",
    "sheet_shared": "Enako kot ti",
    "sheet_unique": "Edinstvena izbira",
    "share_label": "IZBIRE",
    "share_most_picked": "NAJPOGOSTEJE",
    "share_unique_picks": "EDINSTVENE IZBIRE",
    "share_unique_sub": "kolesarji, ki jih je izbral le eden",
    "scout2_title": "Scout",
    "scout2_originality": "TVOJA ORIGINALNOST",
    "scout2_twin": "TVOJ DVOJČEK",
    "scout2_identical": "ENAKE IZBIRE",
    "scout2_identical_sub": "igralci z isto izbiro",
    "scout2_bold": "Drzen",
    "scout2_balanced": "Uravnotežen",
    "scout2_aligned": "Prilagojen",
    "scout2_in_common": "{{count}} od {{total}} skupnih",
    "scout2_none": "Nihče",
    "scout2_popularity": "Priljubljenost kolesarjev",
    "scout2_tap_hint": "Tapni kolesarja, da ga označiš v tabeli",
    "scout2_your_picks": "Tvoje izbire",
    "scout2_also_by": "Izbral tudi {{names}}",
    "scout2_only_you": "Samo ti",
    "scout2_outsiders": "Outsiderji",
    "finished_banner": "Dirka je končana · si {{pos}}. s {{pts}} točkami",
    "finished_banner_nopos": "Dirka je končana",
    "finished_cta": "Lestvica",
    "scout2_like_you": "Kdo je igral kot ti",
    "scout2_twins_card": "TVOJI DVOJČKI",
    "scout2_same_as_you": "{{count}} z isto izbiro kot ti",
    "scout2_same_picks": "Ista izbira",
    "scout2_group_count": "{{count}} igralcev",
    "scout2_no_common": "Nobenega skupnega kolesarja z",
    "scout2_other_identical": "Druge enake izbire",
    "result_title": "Kako je šlo",
    "result_total": "Zbral si {{pts}} točk",
    "result_pick_line": "napovedano {{slot}}. · prispel {{rank}}.",
    "result_dnf": "brez uvrstitve",
    "result_best": "Tvoj najboljši",
    "result_worst": "Največ te je stalo",
    "result_malus": "Zmagovalec ni izbran",
    "result_bonus_top10": "Vsi v prvi deseterici",
    "result_bonus_top15": "Vsi v prvi petnajsterici",
    "result_winner": "Zmagovalec",
    "result_winner_owners": "izbralo {{count}} od {{total}}",
    "result_nobody": "Nihče ga ni imel",
    "result_difference": "Naredil je razliko",
    "result_difference_sub": "tisti, ki so ga imeli, so v povprečju zbrali {{delta}} točk glede na ostale",
    "result_flop": "Potopil je marsikoga",
    "result_flop_sub": "tisti, ki so ga imeli, so v povprečju zbrali {{delta}} točk glede na ostale",
    "rules_title": "Pravila na kratko",
    "rules_1": "En kolesar na etapo, trije na kronometrih.",
    "rules_2": "Kolesarja ni mogoče uporabiti dvakrat v isti dirki.",
    "rules_3": "Če izpustiš celo samo eno etapo, si izven dirke: lahko spremljaš, ne moreš pa igrati.",
    "rules_flip": "Flip: samo enkrat na dirko določiš rezervnega kolesarja; šteje namesto tvojega le, če pride v cilj bolje.",
    "profile_flat": "Ravninska",
    "profile_hilly": "Hribovita",
    "profile_mountain": "Gorska",
    "profile_itt": "Kronometer",
    "profile_ttt": "Ekipni kronometer",
    "view_by_rider": "Po kolesarju",
    "view_by_player": "Po igralcu",
    "tour_summary": "{{riders}} kolesarjev, ki jih je izbralo {{players}} igralcev",
    "your_pick": "Tvoja izbira",
    "tour_your_result": "Tvoj rezultat",
    "tour_stage_winner": "Zmagovalec etape",
    "stage_finished_banner": "Etapa je končana · si {{pos}}. na etapi ({{gap}})",
    "share_label_stage": "IZBIRE ETAPE",
    "share_distinct_riders": "RAZLIČNI KOLESARJI",
    "scout_t_position": "SI V",
    "scout_t_break": "UBEŽNIKIH",
    "scout_t_small": "MAJHNI SKUPINI",
    "scout_t_group": "GLAVNEM POLJU",
    "scout_t_with": "z {{count}} igralci",
    "scout_t_alone": "samo ti",
    "scout_t_leader": "VODILNI JE IZBRAL",
    "scout_t_jerseys": "Majice: kaj so izbrali",
    "scout_t_breakaway": "V ubežni skupini",
    "closes_at": "Zapre se {{when}}",
    "closes_in": "Zapre se čez {{time}}",
    "profile_title": "Višinski profil",
    "profile_climbs": "Vzponi",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Višinski profil: {{km}} km, najvišja točka {{max}} m, {{n}} glavnih vzponov",
    "profile_sprint": "S = vmesni sprint",
    "profile_tap_climb": "Tapnite vzpon za podrobnosti",
    "profile_sprint_bonus": "Šprint · bonus",
    "climb_base": "Vznožje",
    "climb_summit": "Vrh",
    "climb_avg": "Povprečni naklon",
    "climb_length": "Dolžina",
    "profile_bonus": "B = bonus točka"
  },
  "join": {
    "back_home": "Nazaj na domačo stran",
    "welcome": "Dobrodošel v ligi!",
    "already_member": "Že si član te lige.",
    "error": "Ni bilo mogoče vstopiti v ligo.",
    "joining": "Dostop do lige...",
    "success": "Dostop uspešen!"
  },
  "leaderboard": {
    "stage_cancelled": "Etapa {{n}} odpovedana: ne šteje v razvrstitev",
    "loading": "Nalaganje...",
    "no_result_title": "Ni rezultatov",
    "no_result_sub": "Rezultati te dirke še niso na voljo.",
    "gc_rank": "Skupna razvrstitev",
    "team_no_data": "Za to etapo ni podatkov o ekipah.",
    "team_title": "EKIPNA RAZVRSTITEV",
    "stage": "Etapa {{n}}",
    "general": "Skupno",
    "stage_rank": "Razvrstitev etape {{n}}",
    "no_data_title": "Podatki niso na voljo",
    "no_data_sub": "Razvrstitev za to etapo še ni bila izračunana.",
    "one_day_race": "Enodnevna dirka",
    "title": "Lestvica",
    "no_data": "Ni razpoložljivih podatkov.",
    "share": "Deli",
    "jersey_tempo": "Čas",
    "jersey_punti": "Točke",
    "jersey_gpm": "Gore",
    "tab_individual": "Posamično",
    "tab_team": "Ekipno",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "V TEKU",
    "race_tag_done": "KONČANA",
    "race_tag_soon": "KMALU",
    "leader_label": "V majici",
    "lead_over_second": "{{gap}} pred 2.",
    "winner": "Zmagovalec",
    "sheet_total": "Skupaj",
    "tie": "izenačeno",
    "top10_count": "{{count}} v prvi deseterici",
    "has_winner": "Ima zmagovalca",
    "my_rank": "Tvoj položaj",
    "counts_for_team": "Šteje za ekipo",
    "not_counting": "Ne šteje",
    "share_label": "LESTVICA",
    "gap_above": "{{gap}} do {{pos}}.",
    "gap_below": "{{gap}} pred {{pos}}.",
    "trend_up": "Navzgor za {{n}}",
    "trend_down": "Navzdol za {{n}}",
    "trend_same": "Položaj nespremenjen",
    "sheet_by_stage": "Etapa za etapo"
  },
  "leagues": {
    "albo": "Zbirka nagrad",
    "no_podio": "še ni dosegel uvrstitve na stopničke.",
    "victories": "Zmage",
    "second": "2. mesto",
    "third": "3. mesto",
    "races_count_one": "1 dirka",
    "races_count_many": "{{count}} dirke",
    "races_count_other": "{{count}} dirk",
    "player_a": "-- Igralec A --",
    "player_b": "-- Igralec B --",
    "draws_one": "1 neodločen izid",
    "draws_many": "{{count}} neodločeni izidi",
    "draws_other": "{{count}} neodločenih izidov",
    "on_races_one": "od 1 dirke",
    "on_races_many": "od {{count}} dirk",
    "on_races_other": "od {{count}} dirk",
    "no_common": "Ni skupnih dirk z rezultati.",
    "settings": "NASTAVITVE",
    "your_position": "Tvoj položaj",
    "stagionale": "Sezonska lestvica",
    "hide": "SKRIJ",
    "show_all_one": "PRIKAŽI VSE (še 1)",
    "show_all_many": "PRIKAŽI VSE (še {{count}})",
    "show_all_other": "PRIKAŽI VSE (še {{count}})",
    "no_data": "Trenutno ni razpoložljivih podatkov.",
    "head2head": "Neposredni dvoboj",
    "races_count": "{{count}} dirk",
    "draws": "{{count}} neodločenih",
    "on_races": "od {{count}} dirk",
    "show_all": "PRIKAŽI VSE (še {{count}})",
    "badge_empty_1": "Še brez značk — slava te čaka! 🚴",
    "badge_empty_2": "Trenutno brez dosežkov, a vsaka dirka je priložnost. 💪",
    "badge_empty_3": "Še vedno brez značk — veliki prvaki začnejo od ničle. 🏅",
    "badge_empty_4": "Prva značka je vedno najtežja. Skoraj smo tam! ⚡",
    "gap_to_podium": "{{gap}} točk do odra za zmagovalce",
    "gap_to_prev": "{{gap}} točk za {{pos}}.",
    "lead_over_next": "+{{gap}} točk pred {{pos}}.",
    "invite_title": "Igraš sam?",
    "invite_body": "Povabi prijatelje, da igrate skupaj v tej ligi.",
    "invite_cta": "Povabi prijatelje",
    "pick_member": "Izberi igralca",
    "position_a11y": "Mesto {{pos}}",
    "load_error": "Lige ni bilo mogoče naložiti.",
    "tab_standings": "Lestvica",
    "tab_stats": "Statistika",
    "tab_rivalry": "Izzivi"
  },
  "league": {
    "member_count_one": "1 uporabnik v tej ligi",
    "member_count_many": "{{count}} uporabniki v tej ligi",
    "member_count_other": "{{count}} uporabnikov v tej ligi",
    "index_join": "Pridruži se",
    "index_create": "Ustvari ligo",
    "manage_title": "Upravljanje {{name}}",
    "err_name": "Vnesi ime",
    "err_password": "Vnesi geslo",
    "err_creation": "Napaka pri ustvarjanju",
    "create_title": "Ustvari novo ligo",
    "create": "Ustvari ligo",
    "privacy": "Zasebnost",
    "public": "Javna",
    "private": "Zasebna",
    "err_join": "Napaka ali si že prijavljen",
    "join_title": "Pridruži se ligi",
    "search_placeholder": "Išči po imenu...",
    "search": "Išči",
    "no_leagues_found": "Nobena liga ni bila najdena",
    "join_btn": "Pridruži se",
    "password_insert": "Vnesi geslo:",
    "calendar_section": "Koledar",
    "calendar_desc_admin": "Upravljaj dirke lige",
    "calendar_desc_user": "Dirke v koledarju",
    "manage": "Upravljaj",
    "view": "Prikaži",
    "calendar_title": "Koledar lige",
    "calendar_save_one": "Shrani koledar (1 dirka)",
    "calendar_save_many": "Shrani koledar ({{count}} dirke)",
    "calendar_save_other": "Shrani koledar ({{count}} dirk)",
    "races_selected_one": "1 dirka izbrana",
    "races_selected_many": "{{count}} dirke izbrane",
    "races_selected_other": "{{count}} dirk izbranih",
    "deselect_all": "Prekliči vse izbire",
    "select_all": "Izberi vse",
    "loading": "Nalaganje...",
    "settings_section": "Nastavitve lige",
    "settings_name": "Ime lige",
    "settings_save": "Shrani",
    "settings_autopick": "Samodejna izbira",
    "settings_autopick_desc": "Če uporabnik ne opravi izbire, sistem izbere najboljšega razpoložljivega kolesarja iz prejšnje etape.",
    "settings_team_race": "Ekipna dirka",
    "settings_team_race_desc": "Omogoči ekipni način za to ligo.",
    "settings_team_size": "Najv. št. članov na ekipo",
    "settings_scoring": "Izračun točk",
    "settings_scoring_best2": "Najboljša 2 — vsota prvih dveh",
    "settings_scoring_avg": "Povprečje vseh članov",
    "settings_flip": "Flip",
    "settings_flip_desc": "Vsak uporabnik lahko za eno izbrano etapo navede jokerskega kolesarja. Pri obračunu točk se samodejno izbere boljši izmed osnovnega kolesarja in flipa. Uporabno le enkrat na dirko.",
    "invite_section": "Povezava za povabilo",
    "invite_loading": "Nalaganje...",
    "invite_copied": "Kopirano!",
    "invite_copy": "Kopiraj",
    "invite_share_btn": "Deli",
    "members_section": "Člani",
    "members_title_admin": "Upravljanje članov",
    "members_title_user": "Člani lige",
    "leaving": "Zapuščanje...",
    "leave": "Zapusti to ligo",
    "admin_badge": "Skrbnik",
    "remove": "Odstrani",
    "pick_admin_title": "Popravek izbir",
    "pick_admin_desc": "Uredi izbire uporabnikov",
    "pick_admin_open": "Odpri",
    "pick_admin_save": "Shrani izbire",
    "pick_admin_none": "— nihče —",
    "pick_admin_search": "Poišči kolesarja ali številko",
    "pick_admin_retired": "odstopil",
    "pick_admin_saved2": "{{set}} izbir nastavljenih, {{removed}} odstranjenih",
    "pick_admin_nochange": "Ni sprememb za shranjevanje",
    "pick_admin_undo": "Razveljavi zadnji popravek",
    "pick_admin_undone": "Popravek razveljavljen",
    "pick_admin_future": "Odstranjenih tudi {{n}} izbir prihodnjih etap z istim kolesarjem",
    "pick_admin_notify": "Obvesti igralce",
    "pick_admin_no_calendar": "Ta dirka ni v koledarju lige: shranjevanje ni mogoče",
    "stats_section": "Statistika",
    "stats_participation": "Udeležba po etapah",
    "stats_title": "Statistika udeležbe",
    "stats_no_data": "Ni razpoložljivih podatkov.",
    "stats_error": "Statistike ni bilo mogoče naložiti. Poskusi znova.",
    "team_loading": "Nalaganje ekipe...",
    "team_section": "Ekipa",
    "team_cancel": "Prekliči",
    "team_create_btn": "+ Ustvari ekipo",
    "team_locked": "Dirka poteka — spremembe ekipe onemogočene",
    "team_create": "Ustvari ekipo",
    "team_members_count_one": "1/{{max}} član",
    "team_members_count_many": "{{count}}/{{max}} člani",
    "team_members_count_other": "{{count}}/{{max}} članov",
    "team_invite_btn": "+ Povabi",
    "team_leave": "Zapusti",
    "team_save": "Shrani",
    "team_pwd_hint": "Pusti prazno, da ekipo narediš javno",
    "team_pending": "Čaka na odgovor",
    "team_invite_cancel": "Prekliči",
    "team_invite_section": "Povabi člana",
    "team_no_invitable": "Ni članov na voljo za povabilo.",
    "team_invite_action": "Povabi",
    "team_private_label": "\"{{name}}\" je zasebna:",
    "team_join_action": "Vstopi",
    "team_empty": "Še ni ekip — bodi prvi, ki jo ustvari!",
    "team_mine": "TVOJA",
    "team_join": "Pridruži se",
    "team_full": "Polna",
    "team_members": "Člani",
    "join": "Pridruži se",
    "calendar_save": "Shrani koledar ({{count}} dirk)",
    "invite_share": "Deli",
    "races_selected": "{{count}} dirk izbranih",
    "invite_desc": "Deli to povezavo — kdor klikne, se neposredno pridruži ligi.",
    "invite_desc_pwd": "Deli to povezavo — kdor klikne, se neposredno pridruži ligi z že vključenim geslom.",
    "member_count": "{{count}} uporabnikov v tej ligi",
    "team_members_count": "{{count}}/{{max}} članov",
    "create_name_placeholder": "Npr.: Prijatelji pedal",
    "create_password_placeholder": "Geslo za dostop",
    "calendar_saved": "Koledar shranjen!",
    "err_name_empty": "Ime ne sme biti prazno",
    "settings_saved": "Nastavitve shranjene!",
    "pwd_public_placeholder": "Pusti prazno za javno ligo",
    "invite_share_title": "Pridruži se {{name}} na Virtua Cycling",
    "invite_share_message": "Pridruži se ligi \"{{name}}\" na Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "Ponovno ustvariti povezavo? Vse prejšnje povezave bodo prenehale delovati.",
    "invite_regenerating": "Ponovno ustvarjanje...",
    "invite_regen_btn": "Ponovno ustvari povezavo (prekliče prejšnje)",
    "confirm_remove": "Odstrani {{name}} iz lige?",
    "member_removed": "{{name}} odstranjen",
    "confirm_demote": "Ali želiš {{name}} odvzeti skrbniške pravice?",
    "confirm_promote": "Ali želiš {{name}} povišati v skrbnika?",
    "demote_admin": "Odstrani skrbnika",
    "promote_admin": "Skrbnik",
    "pick_admin_saved": "{{count}} izbir shranjenih!",
    "confirm_team_leave": "Zapustiti ekipo?",
    "confirm_kick": "Odstraniti {{name}} iz ekipe?",
    "team_invite_sent": "Povabilo poslano!",
    "team_pwd_saved": "Geslo posodobljeno!",
    "team_name_placeholder": "Ime ekipe...",
    "team_rename_placeholder": "Novo ime...",
    "team_newpwd_placeholder": "Novo geslo..."
  },
  "profile": {
    "nick_title": "Vzdevek",
    "theme_title": "Prilagajanje teme",
    "theme_dark": "Temno",
    "theme_light": "Svetlo",
    "lang": "Jezik",
    "save_lang": "Shrani jezik",
    "nick_success": "Vzdevek posodobljen!",
    "nick": "Vzdevek",
    "nick_placeholder": "Vnesi vzdevek",
    "update_btn": "Posodobi",
    "pass": "Geslo",
    "show_pass": "Prikaži geslo",
    "update_pass": "Posodobi geslo",
    "avatars_title": "Avatarji",
    "avatars": "Prikaži avatarje",
    "avatars_sub": "Izklopi, če je telefon počasen: namesto avatarjev boš videl drese kolesarjev in imena igralcev. Tvoj avatar na začetnem zaslonu ostane.",
    "notif_title": "Potisna obvestila",
    "my_leagues": "Moje lige",
    "members_count_one": "1 član",
    "members_count_many": "{{count}} člani",
    "members_count_other": "{{count}} članov",
    "default_badge": "PRIVZETO",
    "set_default": "Nastavi kot privzeto",
    "leave": "Zapusti",
    "settings": "Nastavitve profila",
    "hi": "Živjo",
    "intro": "tukaj lahko upravljaš svoj račun.",
    "admin_panel": "Skrbniška plošča",
    "theme_sub": "Sinhronizirano na vseh tvojih napravah.",
    "lang_title": "Jezik / Language",
    "security_title": "Dostop in varnost",
    "security_success": "Podatki posodobljeni!",
    "notif_enabled": "Omogoči obvestila",
    "notif_enabled_sub": "Omogoči ali onemogoči vsa obvestila",
    "notif_results": "Rezultati dirke",
    "notif_results_sub": "Obvestilo ob objavi rezultatov",
    "notif_startlist": "Startna lista",
    "notif_startlist_sub": "Obvestilo takoj, ko je startna lista na voljo",
    "notif_reminder": "Opomnik za izbiro",
    "notif_reminder_sub": "Prejmi opomnik pred zaprtjem izbir",
    "notif_reminder_off": "Brez opomnika",
    "notif_reminder_no_pick": "Samo če še nisem izbral",
    "notif_reminder_always": "Vedno",
    "notif_saving": "Shranjevanje...",
    "notif_saved": "Nastavitve shranjene!",
    "notif_error": "Napaka pri shranjevanju",
    "nick_taken": "Vzdevek je že v uporabi",
    "pass_min_length": "Geslo mora vsebovati vsaj 6 znakov",
    "pass_mismatch": "Gesli se ne ujemata",
    "new_pass_placeholder": "Novo geslo",
    "league_default_updated": "Privzeta liga posodobljena!",
    "league_leave_confirm": "Ali si prepričan, da želiš zapustiti \"{{name}}\"?",
    "league_left": "Ligo si zapustil.",
    "confirm_password": "Potrdi geslo",
    "avatar_title": "Tvoj avatar",
    "avatar_jersey": "Majica",
    "avatar_cap": "Kapa",
    "avatar_glasses": "Očala",
    "avatar_cyclist": "Kolesar",
    "avatar_patch": "Našitek majice",
    "avatar_saved": "Avatar shranjen!",
    "avatar_save_btn": "Shrani avatar",
    "rules": "Pravilnik",
    "report_bug": "Prijavi napako",
    "bug_sent": "Prijava poslana, hvala!",
    "bug_placeholder": "Opiši težavo...",
    "group_identity": "Identiteta",
    "group_account": "Račun",
    "group_contact": "Kontaktirajte nas",
    "group_danger": "Nevarno območje",
    "change_pass": "Spremeni",
    "cancel": "Prekliči",
    "show_more": "Prikaži vse ({{count}} več)",
    "show_less": "Prikaži manj",
    "delete_confirm": "Ali res želiš izbrisati svoj račun? Dejanja ni mogoče razveljaviti, vsi tvoji podatki bodo trajno izbrisani.",
    "delete_desc": "Brisanje je trajno in odstrani vse tvoje podatke, izbire, lige in nastavitve.",
    "delete_btn": "Izbriši moj račun",
    "delete_league_owner": "Ustvaril si ligo z drugimi člani: če izbrišeš račun, bo izginila za vse. Kontaktiraj nas za prenos ali jo najprej izbriši.",
    "replay_tour": "Oglej si vodič znova",
    "leave_feedback": "Pošlji povratne informacije",
    "feedback_placeholder": "Ideja, predlog ali komentar: z veseljem ga preberemo...",
    "feedback_sent": "Hvala za povratne informacije! 🙏",
    "rate_app": "Oceni Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Vnesi vzdevek",
    "err_nickname_taken": "Vzdevek je že v uporabi",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Vnesi svoj e-poštni naslov",
    "forgot_sent": "E-pošta poslana! Preveri svoj nabiralnik.",
    "tagline": "Zavzemi svoje mesto v spremljevalnem vozilu.",
    "tab_login": "Prijava",
    "tab_register": "Registracija",
    "forgot_hint": "Vnesi svoj e-poštni naslov in poslali ti bomo povezavo za ponastavitev gesla.",
    "email": "E-pošta",
    "forgot_send": "Pošlji povezavo",
    "back": "← Nazaj na prijavo",
    "nickname": "Vzdevek",
    "password": "Geslo",
    "btn_login": "PRIJAVA",
    "btn_register": "REGISTRACIJA",
    "forgot_pass": "Pozabljeno geslo?",
    "or": "ali",
    "google_login": "Prijava z Google",
    "google_register": "Registracija z Google",
    "privacy_text": "Z nadaljevanjem sprejemaš naš",
    "privacy_link": "Pravilnik o zasebnosti",
    "loading": "…"
  },
  "news": {
    "title": "NOVICE",
    "loading": "Nalaganje...",
    "no_news": "Ni razpoložljivih novic.",
    "pinned": "Izpostavljeno",
    "not_found": "Članek ni bil najden.",
    "open_external": "Odpri članek na {{source}}",
    "disclaimer": "Naslovi in povezave prihajajo iz zunanjih virov: članki pripadajo svojim založnikom.",
    "tab_unread_one": "{{count}} nova novica",
    "tab_unread_two": "{{count}} novici",
    "tab_unread_few": "{{count}} nove novice",
    "tab_unread_other": "{{count}} novic",
    "load_error": "Novic nismo mogli naložiti."
  },
  "reset_password": {
    "title": "NOVO GESLO",
    "subtitle": "Izberi novo geslo za svoj račun",
    "show_pass": "Prikaži geslo",
    "loading": "Preverjanje povezave...",
    "success": "Geslo posodobljeno! Preusmerjen boš..."
  },
  "confirm": {
    "verifying": "Preverjanje...",
    "error": "Napaka med potrjevanjem.",
    "success": "E-pošta potrjena! Preusmerjen boš...",
    "missing_params": "Manjkajoči parametri v povezavi.",
    "missing_params_detail": "Prepričaj se, da si kliknil pravilno povezavo iz e-pošte.",
    "critical_error": "Kritična napaka povezave."
  },
  "notifications": {
    "title": "Obvestila",
    "empty": "Še ni obvestil",
    "accept": "Sprejmi",
    "refuse": "Zavrni",
    "now": "Zdaj",
    "minutes_ago": "pred {{count}} min",
    "hours_ago": "pred {{count}} h"
  },
  "quiz": {
    "card_sub": "10 vprašanj o Tour de France — koliko veš?",
    "loading": "Nalaganje vprašanj...",
    "no_questions": "Nobeno vprašanje ni na voljo",
    "question_count": "Vprašanje {{current}} od {{total}}",
    "easy": "Lahko",
    "medium": "Srednje",
    "hard": "Težko",
    "correct": "Pravilen odgovor!",
    "wrong": "Napačno. Pravilen odgovor je bil: {{answer}}",
    "next": "Naslednje",
    "see_result": "Poglej rezultat",
    "restart": "Igraj znova",
    "result_excellent": "Si pravi strokovnjak za kolesarstvo!",
    "result_good": "Odlično poznavanje Tour de France!",
    "result_average": "Solidno znanje. Poglej si več dirk!",
    "result_poor": "Prostora za izboljšave je še dovolj — a zato se pač kolesari!"
  },
  "person": {
    "hint": "Izberi videz svojega avatarja: videl ga boš na začetnem zaslonu.",
    "gender": "Spol",
    "man": "Moški",
    "woman": "Ženska",
    "hair_short": "Kratki",
    "hair_curly": "Kodrasti",
    "hair_wavy": "Valoviti",
    "hair_shaved": "Obrit",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Pokrivalo",
    "wear_none": "Brez",
    "wear_cap": "Kapa",
    "wear_helmet": "Čelada",
    "glasses": "Očala",
    "glasses_off": "Ne",
    "glasses_on": "Da",
    "jersey": "Dres",
    "jersey_vertical": "Navpično",
    "jersey_horizontal": "Vodoravno",
    "jersey_classic": "Klasičen",
    "jersey_diagonal": "Diagonalno",
    "jersey_dots": "Pike",
    "row_skin": "Koža",
    "row_hair": "Lasje",
    "row_brow": "Obrvi",
    "row_iris": "Oči",
    "row_wear": "Pokrivalo",
    "row_visor": "Senčnik",
    "row_vents": "Zračniki",
    "row_frame": "Okvir očal",
    "save": "SHRANI",
    "saved": "Avatar shranjen",
    "save_error": "Napaka pri shranjevanju",
    "reset": "Ponastavi",
    "reset_done": "Ponastavljeno",
    "tab_face": "Obraz",
    "tab_hair": "Lasje",
    "tab_gear": "Dodatki",
    "tab_jersey": "Dres",
    "row_lens": "Leče",
    "jersey_body": "Telo",
    "jersey_sleeves": "Rokavi",
    "jersey_band": "Pas",
    "jersey_trim": "Ovratnik in manšete",
    "view_mine": "Moj avatar",
    "view_world_champion": "Mavrična majica",
    "world_champion_since": "Svetovni prvak v {{league}} od {{date}}",
    "view_european_champion": "Evropska majica",
    "european_champion_since": "Evropski prvak v {{league}} od {{date}}",
    "view_worldcup_leader": "Majica svetovnega pokala",
    "worldcup_leader_since": "Vodilni na lestvici lige {{league}} od {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Uredi avatar",
    "avatar_cut": "Frizura",
    "avatar_hair": "Lasje",
    "avatar_skin": "Koža",
    "avatar_beard": "Brada",
    "avatar_beard_none": "Brez",
    "avatar_face": "Obraz",
    "avatar_face_none": "Običajen",
    "avatar_face_a": "Vitek",
    "avatar_face_b": "Močan",
    "avatar_face_c": "Mlad",
    "avatar_face_d": "Oglat",
    "avatar_face_e": "Zrel",
    "avatar_face_f": "Nasmejan",
    "avatar_face_g": "Zaprt nasmeh",
    "avatar_brow": "Obrvi",
    "avatar_brow_0": "Običajne",
    "avatar_brow_1": "Tanke",
    "avatar_brow_2": "Goste",
    "avatar_beard_light": "Rahla",
    "avatar_hex": "Druga barva (#RRGGBB)",
    "avatar_save": "Shrani",
    "avatar_reset": "Ponastavi",
    "avatar_undo": "Razveljavi zadnjo spremembo",
    "avatar_saved": "Shranjeno",
    "avatar_bad_hex": "Neveljavna barva: uporabi #RRGGBB",
    "avatar_err": "Shranjevanje ni uspelo",
    "avatar_beard_legend": "1 senca · 2 brki · 3 kratka · 4 polna · 6 brki+kozja brada · 7 krog · 8 rahla brada",
    "hair_wavy_medium": "Srednje valovito",
    "hair_receding": "Umikajoč lasišče",
    "hair_messy": "Razmršeno",
    "hair_buzz": "Zelo kratko",
    "hair_curly_short": "Kratke kodrčke",
    "hair_medium": "Do ramen",
    "hair_flip_off": "Običajna stran",
    "hair_flip_on": "Zrcaljeno",
    "hair_side_part": "Prečka ob strani",
    "hair_slicked_back": "Nazaj",
    "hair_forward": "Naprej",
    "hair_high_line": "Visoka linija las",
    "hair_wavy_short": "Kratki valoviti",
    "hair_curly_medium": "Srednji kodri",
    "hair_receding_short": "Kratko z zalizci",
    "beard_stubble_light": "Rahla brada",
    "hair_long": "Dolgi",
    "hair_ponytail": "Čop",
    "hair_bun": "Figa",
    "hair_long_wavy": "Valovito",
    "hair_braid": "Pletenica",
    "beard": "Brada",
    "beard_none": "Brez",
    "beard_stubble": "Senca",
    "beard_moustache": "Brki",
    "beard_short": "Kratka",
    "beard_full": "Polna",
    "beard_goatee": "Brki in kozja brada",
    "beard_circle": "Krožna",
    "beard_op_normal": "Običajna",
    "beard_op_light": "Rahla",
    "fringe": "Šiška",
    "fringe_off": "Brez",
    "fringe_on": "S šiško"
  },
  "app_update": {
    "title": "Nova različica je pripravljena",
    "body": "Znova zaženi aplikacijo za najnovejše spremembe.",
    "restart": "Znova zaženi",
    "later": "Pozneje"
  },
  "avatar": {
    "invite_title": "Tukaj je tvoj avatar!",
    "invite_body": "Ustvarili smo ti ga: prilagodi ga po svoje.",
    "invite_cta": "Prilagodi",
    "invite_dismiss": "Zapri",
    "edit_a11y": "Prilagodi svoj avatar"
  },
  "jersey_celebration": {
    "ok": "Odlično!"
  },
  "insight": {
    "you": "S tabo",
    "form": "Forma",
    "never": "Še nikoli ga nisi izbral: bi bilo prvič.",
    "picked": "Krat izbran",
    "avg_rank": "Povprečna uvrstitev",
    "avg_gap": "Povprečni zaostanek",
    "best": "Najboljši rezultat",
    "dnf": "Odstopi s tabo",
    "last": "Zadnjič",
    "retired": "odstopil",
    "form_avg": "Povprečje zadnjih 5",
    "season_races": "Dirke v sezoni",
    "top10": "Prvih 10",
    "wins": "Zmage",
    "dnfs": "Odstopi",
    "cat_1": "Ravninske etape",
    "cat_2": "Gorske etape",
    "cat_3": "Hribovite etape",
    "last5": "Zadnjih 5 rezultatov",
    "no_results": "V tej sezoni še ni rezultatov.",
    "open_a11y": "Vpogled v {{name}}",
    "summary": "{{n}}× s tabo · povpr. {{rank}}.",
    "summary_never": "Še nikoli izbran",
    "open": "Vpogled"
  },
  "badges": {
    "title": "Značke",
    "album_title": "Vitrina trofej",
    "earned_of": "{{earned}} od {{total}} značk",
    "open_album": "Odpri vitrino trofej",
    "recent": "Nazadnje pridobljene",
    "next_goals": "Cilji na dosegu",
    "filter_all": "Vse",
    "filter_earned": "Pridobljene",
    "filter_todo": "Za pridobiti",
    "group_gt": "Velike ture",
    "group_monuments": "Spomeniki in klasike",
    "group_picks": "Spretnost pri izbirah",
    "group_consistency": "Vztrajnost",
    "group_league": "Lestvica lige",
    "group_social": "Družabno",
    "group_meta": "Zbirka",
    "tier_1": "Bron",
    "tier_2": "Srebro",
    "tier_3": "Zlato",
    "tier_4": "Platina",
    "tier_special": "Mejnik",
    "secret_title": "Skrivna značka",
    "secret_hint": "Odkrij jo med igranjem.",
    "earned_on": "Pridobljena {{date}}",
    "progress": "{{value}} od {{threshold}}",
    "rarity": "Ima jo {{pct}} % lige ({{n}} od {{m}})",
    "rarity_none": "Še nihče je nima: lahko si prvi.",
    "seasons": "Pridobljene sezone: {{count}}",
    "complete": "Dokončano",
    "locked": "Za pridobiti",
    "player": "Igralec",
    "none_me": "Še nobene značke: naslednja dirka je tvoja priložnost.",
    "none_other": "{{name}} še nima značk.",
    "empty_filter": "S tem filtrom ni ničesar za prikaz.",
    "load_error": "Značk ni bilo mogoče naložiti.",
    "not_enabled": "Značke za to ligo še niso aktivne.",
    "fam": {
      "RE_GT": {
        "title": "Kralj velikih tur",
        "desc": "Dobljene velike ture: {{n}}"
      },
      "WIN_GIRO": {
        "title": "Kralj Gira",
        "desc": "Zmagaj v skupnem seštevku Gira d'Italia"
      },
      "WIN_TOUR": {
        "title": "Kralj Toura",
        "desc": "Zmagaj v skupnem seštevku Toura de France"
      },
      "WIN_VUELTA": {
        "title": "Kralj Vuelte",
        "desc": "Zmagaj v skupnem seštevku Vuelte"
      },
      "GT_PODI": {
        "title": "Stopničke na velikih turah",
        "desc": "Stopničke na velikih turah: {{n}}"
      },
      "GT_DAYS": {
        "title": "Dnevi v majici",
        "desc": "Dnevi kot vodilni v skupnem seštevku: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Roza majica",
        "desc": "Prevzemi vodstvo v skupnem seštevku Gira d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Rumena majica",
        "desc": "Prevzemi vodstvo v skupnem seštevku Toura de France"
      },
      "FIRST_RED": {
        "title": "Rdeča majica",
        "desc": "Prevzemi vodstvo v skupnem seštevku Vuelte"
      },
      "GT_GREEN": {
        "title": "Kralj šprinterjev",
        "desc": "Dobljeni točkovni seštevki na velikih turah: {{n}}"
      },
      "GT_POIS": {
        "title": "Kralj gora",
        "desc": "Dobljeni gorski seštevki na velikih turah: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Lovec na etape",
        "desc": "Dobljene etape na velikih turah: {{n}}"
      },
      "GT_WIRE": {
        "title": "Od začetka do konca",
        "desc": "Vodi skupni seštevek od prve do zadnje etape in zmagaj na veliki turi"
      },
      "GT_COMEBACK": {
        "title": "Vrnitev",
        "desc": "Zmagaj na veliki turi, čeprav si bil po prvem tednu izven prve deseterice"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Popolni triumf",
        "desc": "Zmagaj v skupnem, točkovnem in gorskem seštevku na isti veliki turi"
      },
      "GT_HEARTBREAK": {
        "title": "Grenak poraz",
        "desc": "Vodil si dan pred zadnjo etapo, a nisi zmagal na veliki turi"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Zmagaj na Giru, Touru in Vuelti"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Zmagaj na Giru in Touru v istem letu"
      },
      "RE_MONUMENTI": {
        "title": "Kralj spomenikov",
        "desc": "Dobljeni spomeniki: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Zmagaj na Milano–Sanremo"
      },
      "WIN_FIANDRE": {
        "title": "Flandrija",
        "desc": "Zmagaj na Dirki po Flandriji"
      },
      "WIN_ROUBAIX": {
        "title": "Pekel severa",
        "desc": "Zmagaj na Paris–Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Zmagaj na Liège–Bastogne–Liège"
      },
      "WIN_LOMBARDIA": {
        "title": "Dirka padajočega listja",
        "desc": "Zmagaj na Dirki po Lombardiji"
      },
      "MONUMENTS_SWEEP": {
        "title": "Vsi spomeniki",
        "desc": "Zmagaj na vseh 5 spomenikih"
      },
      "RE_DEL_NORD": {
        "title": "Kralj severa",
        "desc": "Zmagaj v Flandriji in Roubaixu v istem letu"
      },
      "ARDENNES": {
        "title": "Ardenska trojka",
        "desc": "Zmagaj na Amstelu, Flèche Wallonne in Liègeu v istem letu"
      },
      "DUE_MARI": {
        "title": "Dirka dveh morij",
        "desc": "Zmagaj na Paris–Nice in Tirreno–Adriatico v istem letu"
      },
      "MODALITA_POGACAR": {
        "title": "Pogačarjev način",
        "desc": "Zmagaj na vseh 3 velikih turah in vseh 5 spomenikih"
      },
      "RE_CLASSICHE": {
        "title": "Kralj klasik",
        "desc": "Dobljene klasike: {{n}}"
      },
      "RE_TAPPE": {
        "title": "Kralj etapnih dirk",
        "desc": "Dobljene etapne dirke: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Svetovni prvak",
        "desc": "Zmagaj na cestni dirki svetovnega prvenstva"
      },
      "EURO_CHAMP": {
        "title": "Evropski prvak",
        "desc": "Zmagaj na cestni dirki evropskega prvenstva"
      },
      "CRONOMAN": {
        "title": "Specialist za kronometer",
        "desc": "Zmagaj na kronometru svetovnega ali evropskega prvenstva"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Edini v ligi, ki je izbral zmagovalca: {{n}}"
      },
      "PROFETA": {
        "title": "Prerok",
        "desc": "Zmagovalne izbire: {{n}}"
      },
      "FIUTO": {
        "title": "Nos za zmagovalce",
        "desc": "Zmagovalci, ki jih je izbralo malo igralcev: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Zmagovalec dirke",
        "desc": "Dobljene dirke v ligi: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Stalni gost na stopničkah",
        "desc": "Stopničke na dirkah lige: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debi",
        "desc": "Odigraj svojo prvo dirko"
      },
      "PRESENZE": {
        "title": "Prisotnost",
        "desc": "Odigrane dirke: {{n}}"
      },
      "SERIE": {
        "title": "V nizu",
        "desc": "Zaporedno odigrane dirke: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Popolna sezona",
        "desc": "Odigraj vse dirke sezone"
      },
      "LEADER_STAGIONE": {
        "title": "Na čelu",
        "desc": "Dirke, končane na čelu lestvice: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Prvak lige",
        "desc": "Sezono končaj na prvem mestu lestvice"
      },
      "PODIO_LEGA": {
        "title": "Stopničke lige",
        "desc": "Sezono končaj na stopničkah lestvice"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Sezono končaj med prvimi 10 na lestvici"
      },
      "SCALATORE": {
        "title": "Plezalec",
        "desc": "Pridobljena mesta na eni sami dirki: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Ubijalec velikanov",
        "desc": "Dirke, končane pred vodilnim na lestvici: {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Pridobljene značke: {{n}}"
      },
      "LEGGENDA": {
        "title": "Legenda",
        "desc": "Pridobi vse značke"
      }
    },
    "celebration_one": "Nova značka!",
    "celebration_many": "{{n}} novih značk!",
    "celebration_more": "in še {{n}}",
    "share": "Deli",
    "share_label": "ZNAČKA PRIDOBLJENA",
    "share_dialog": "Moja značka: {{name}}",
    "share_text": "Pridobil sem značko »{{name}}« v Virtua Cycling! {{site}}",
    "showcase_title": "Izpostavljeno",
    "showcase_hint": "Izberi do 3 značke za razstavo. Če ne izbereš, pokažemo tvoje najredkejše.",
    "showcase_edit": "Uredi",
    "showcase_auto": "Samodejno",
    "showcase_save": "Shrani",
    "showcase_count": "Izbrano: {{n}} od 3",
    "showcase_err": "Izbire ni bilo mogoče shraniti.",
    "showcase_a11y": "Tvoje izpostavljene značke",
    "showcase_none": "Pridobi svojo prvo značko, da jo vidiš tukaj.",
    "showcase_pick_empty": "Še nimaš značk za vitrino.",
    "jerseys_title": "Majice velikih tur",
    "jersey_pink": "Roza majica",
    "jersey_yellow": "Rumena majica",
    "jersey_red": "Rdeča majica",
    "days_caption": "Dnevi v majici",
    "section_jerseys": "Majice",
    "special_title": "Posebne majice",
    "special_now": "Trenutno nošena",
    "trophy_sub": "Značke, majice in častna lestvica"
  },
  "rivalry": {
    "title": "Izzivi",
    "intro": "Izberi nasprotnika. Če sprejme, od te dirke naprej točko dobi tisti, ki konča pred drugim. Cela liga vidi, kako gre.",
    "slots": "Poslani izzivi: {{used}} od {{max}}",
    "limit_reached": "Poslal si največ izzivov. Prekliči ali končaj enega, da lahko pošlješ novega.",
    "no_candidates": "Ni drugih igralcev, ki bi jih lahko izzval.",
    "challenge_cta": "Pošlji izziv",
    "pick_title": "Koga želiš izzvati?",
    "confirm_challenge": "Izzvati {{name}}? Prejel bo zahtevo in jo lahko sprejme ali zavrne.",
    "sent": "Zahteva poslana igralcu {{name}}.",
    "accepted": "Sprejel si izziv z igralcem {{name}}.",
    "incoming_title": "Prejete zahteve",
    "incoming_line": "{{name}} te izziva",
    "accept": "Sprejmi",
    "decline": "Zavrni",
    "waiting_title": "Čakanje na odgovor",
    "waiting_line": "Čakanje na {{name}}",
    "cancel": "Prekliči",
    "mine_title": "Tvoji izzivi",
    "league_title": "V ligi",
    "ended_title": "Končani izzivi: {{count}}",
    "empty": "V ligi ni izzivov v teku. Pošlji prvega!",
    "vs": "proti",
    "score_a11y": "{{a}} proti {{b}}",
    "last_point": "Zadnja točka: {{name}} na dirki {{race}}",
    "no_races": "Še brez dirk",
    "won_by": "Zmagal: {{name}}",
    "drawn": "Končalo se je neodločeno",
    "detail_title": "Izziv",
    "results_title": "Dirka za dirko",
    "no_results": "Točk še ni bilo podeljenih.",
    "point_to": "Točka za {{name}}",
    "end_cta": "Končaj izziv",
    "end_confirm": "Končati izziv z igralcem {{name}}?",
    "rematch": "Povratni dvoboj",
    "load_error": "Izzivov ni bilo mogoče naložiti.",
    "err_limit": "Že si poslal največ izzivov.",
    "err_exists": "Že ste v izzivu ali pa je zahteva v teku.",
    "err_invalid": "Ta zahteva ni več veljavna.",
    "err_generic": "Dejanja ni bilo mogoče dokončati.",
    "notif_accepted": "Izziv sprejet",
    "notif_declined": "Izziv zavrnjen"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Tekmovanje"
  },
  "no_league": {
    "title": "Ne sodeluješ v nobeni ligi {{comp}}",
    "body": "Pridružiš se lahko ligi ali ustvariš novo v razdelku Lige.",
    "body_official": "V uradno ligo se lahko pridružiš kadar koli ali pa se pridružiš zasebni ligi oziroma jo ustvariš v razdelku Lige.",
    "join": "Pridruži se {{name}}",
    "go_leagues": "Pojdi na lige"
  }
}
